module.exports = __webpack_public_path__ + "static/media/add_image.8318da64.svg";